import type { ValueOf } from 'type-fest'
export const PRE_MERGE_TABLE_ROW_KEY = 'mergeId'

export const MERGE_TYPE = {
  /** 人工 */
  manual: 0,
  /** 智能 */
  auto: 1,
} as const

/** 视图类型 */
export const VIEW_PAGE_TYPE = {
  /**提交成功 */
  submit: 'submit',
  /** 超时，预合单失效 */
  timeout: 'timeout',
  /** 合单列表展示 */
  list: 'list',
} as const
/**
 * 视图类型
 * submit 提交成功
 * timeout 超时
 * list 合单列表展示
 * */
export type ViewPageType = ValueOf<typeof VIEW_PAGE_TYPE>

export const ERROR_CODE = {
  /**预合单快照已过期 */
  timeout: 'LST-140001-B1004',
}
